var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMabraLogo = function SvgMabraLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 63 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M52.373 5.53h-.667a2.5 2.5 0 0 0-.668.086c-1.055.26-1.906 1.008-1.986 1.812V5.529h-2.646v10.102h2.645v-5.9a1.8 1.8 0 0 1 .212-.638 2.04 2.04 0 0 1 1.775-1.035h1.323V5.529z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m17.907 2.371-5.972 8.519V2.37H9.29L0 15.627h3.318L9.277 7.11v8.518h2.65l4.229-6.033-4.22 6.033 5.963-8.49v-.028 8.518h2.646V2.38h-2.638z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M27.53 3.269a.915.915 0 0 1-.912-.922c0-.51.407-.921.912-.921.504 0 .911.411.911.921a.913.913 0 0 1-.912.922m0-3.051a2.125 2.125 0 0 0-2.118 2.133c0 1.177.946 2.133 2.117 2.133a2.126 2.126 0 0 0 2.118-2.133c0-1.18-.946-2.133-2.117-2.133",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M40.64 12.853h-3.661V9.175h3.66c.99 0 1.794.825 1.794 1.839s-.804 1.839-1.794 1.839M36.975 4.1h3.456c.75 0 1.357.622 1.357 1.39 0 .77-.607 1.391-1.357 1.391h-3.456zm5.605 3.708a3.18 3.18 0 0 0 1.744-2.82c0-1.756-1.438-3.17-3.209-3.17h-6.703V15.15h6.726c.313 0 .63-.016.936-.095A3.806 3.806 0 0 0 45 11.355c.004-1.609-1.001-2.98-2.42-3.547",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M60.328 11.451c-.403 1.037-1.354 1.78-2.471 1.78-1.475 0-2.676-1.306-2.676-2.9 0-1.599 1.2-2.896 2.676-2.896 1.117 0 2.068.74 2.47 1.787.138.346.207.723.207 1.12.007.386-.069.756-.206 1.11m0-6.249v.783a4.8 4.8 0 0 0-2.89-.967c-2.769 0-5.026 2.385-5.026 5.333 0 2.94 2.257 5.333 5.026 5.333a4.83 4.83 0 0 0 2.89-.968v.796H63V5.201z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M29.622 11.451c-.403 1.037-1.354 1.78-2.47 1.78-1.476 0-2.677-1.306-2.677-2.9 0-1.599 1.201-2.896 2.676-2.896 1.117 0 2.068.74 2.471 1.787.137.346.206.723.206 1.12.008.386-.069.756-.206 1.11m0-6.249v.783a4.8 4.8 0 0 0-2.89-.967c-2.769 0-5.026 2.385-5.026 5.333 0 2.94 2.257 5.333 5.026 5.333a4.84 4.84 0 0 0 2.89-.968v.796h2.672V5.201z",
    clipRule: "evenodd"
  })));
};
export default SvgMabraLogo;